// extracted by mini-css-extract-plugin
export default {"languageOption":"language-option_languageOption__XNz3Q"};